import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ETipoRelatorio } from 'src/app/enums/relatorios/ETipoRelatorio.enum';
import { IRelatorioFranquiaPorMaquinaResponseData } from 'src/app/interfaces/relatorio/FranquiaPorMaquina/IRelatorioFranquiaPorMaquinaResponseData';
import { RelatorioFranquiaPorMaquinaService } from 'src/app/services/relatorios/franquia-por-maquina/relatorio-franquia-por-maquina.service';

@Component({
  selector: 'app-relatorio-franquia-por-maquina',
  templateUrl: './relatorio-franquia-por-maquina.component.html',
  styleUrls: ['./relatorio-franquia-por-maquina.component.scss']
})
export class RelatorioFranquiaPorMaquinaComponent implements OnInit {
  private subscriptions$ = new Subscription();
  relatorio: IRelatorioFranquiaPorMaquinaResponseData;
  codigoContrato: string;
  mesAno: string;

  constructor(
    private relatorioFranquiaGlobalService: RelatorioFranquiaPorMaquinaService,
    private route: ActivatedRoute
  ) {}

  getDadosRelatorioFranquiaPorMaquina() {
    this.subscriptions$.add(
      this.relatorioFranquiaGlobalService
        .postRelatorioFranquiaPorMaquina({
          codigoContrato: this.codigoContrato,
          mesReferencia: this.mesAno,
          tipoExportacao: ETipoRelatorio.PDF
        })
        .subscribe({
          next: ({ data }) => {
            this.relatorio = data;
          }
        })
    );
  }
  ngOnInit() {
    this.route.params.subscribe(
      (params) => (
        (this.codigoContrato = params['codContrato']),
        (this.mesAno = params['mesAno'])
      )
    );
    this.getDadosRelatorioFranquiaPorMaquina();
  }
}
